import { NavigationExtras, Router } from '@angular/router';

/**
 * Navigates to a destination route **AND** refreshes the component, even if current route matches destination.
 * @param router The `Router` instance.
 * @param destinationRoute The destination route.
 * @param extras Optional. `NavigationExtras` from `@angular/router`.
 */
export const navigateWithRefresh = (router: Router, destinationRoute: string, extras?: NavigationExtras, isIntegratedLogin?: boolean) => {
  const shouldRefresh = isIntegratedLogin
    ? router.url === `${destinationRoute}?integrationContext=${extras?.queryParams?.integrationContext}`
    : router.url === destinationRoute;

  if (shouldRefresh) {
    router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
      router.navigate([destinationRoute], extras);
    });
  } else {
    router.navigate([destinationRoute], extras);
  }
};
